import { APIUserType } from '@cd3p/core/types/api';
import {
  hideTicketSensitiveFields,
  ticketHasSensitiveData,
} from '@cd3p/core/utils/sensitiveData';

import { TicketsListState } from 'modules/common/ticketsList';
import { TrackingState } from 'modules/tracking';

export const ticketsMapper = (
  ticketsItems: TicketsListState['tickets']['items'],
  trackingItems: TrackingState['items'],
  userType?: APIUserType,
) => {
  return ticketsItems.map(item => ({
    ...(ticketHasSensitiveData(item, userType)
      ? hideTicketSensitiveFields(item)
      : item),
    timeOfArrival:
      trackingItems?.[item.truck?.truckNumber || '']?.timeOfArrival || null,
  }));
};
